import React from "react";

export default function HeadingContainer({ children }) {
  return <div className="flex justify-between align-bottom mx-8 mt-10">{children}</div>;
}
